export default "__VITE_ASSET__2911eb3d__"